// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedCustomer: Object,
};

const DeleteCustomer = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedCustomer,
  } = props;

  const deleteCustomer = () => {
    submit(selectedCustomer.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteCustomer} type="danger">Delete</SpButton>,
      ]}
      title="Delete Table"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this table?</div>
        <SpH5 className="pb-3">
          <div>{selectedCustomer.shopTable.name}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteCustomer;
